export const ParsingStatusValues = {
    success: 'SUCCESS',
    failure: 'FAILURE'
};

export class DriverLicenseParsingLogInfo {
    status: string;
    duration: string;
    filename: string;
    fileSize: string;
    failureReason: string;
    completedOnServer: boolean;
}
